module.exports = __webpack_public_path__ + "media/stylesheets/images/belcy_logo-4b8c1a5b3a5a4cf9aea7595c3a295c91.png";